import React from 'react';
import LoginEditor from './Login.editor';
import LoginProperties from './Login.properties';
import { registerComponent, registerSkinnableComponent } from '../registry';
import { LoginSkinnable } from './LoginSkinnable';
import ComponentSkinWrapper from '../../skins/ComponentSkinWrapper';
import { COMPONENT_TYPES } from '../../../constants';

// 스킨 가능한 컴포넌트로 등록
registerSkinnableComponent(LoginSkinnable);

// 외부 스킨 지원을 위한 래퍼 컴포넌트
const LoginWrapper: React.FC<any> = (props) => {
  const selectedSkin = props.skin || props.componentProps?.skin || 'basic';
  
  return (
    <ComponentSkinWrapper 
      component={LoginSkinnable}
      componentData={props}
      skinId={selectedSkin}
      mode={props.isPreview ? 'preview' : 'production'}
      editorProps={props}
    />
  );
};

// 레거시 호환성을 위한 기존 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.LOGIN,
  component: LoginWrapper,
  editorComponent: LoginEditor,
  properties: LoginProperties,
  defaultProps: {
    style: {
      padding: '20px',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      maxWidth: '500px',
      margin: '30px auto'
    },
    componentProps: {
      skin: 'basic',
      redirectUrl: '/',
      backgroundType: 'image',
      backgroundUrl: '',
      title: '로그인',
      titleColor: '#333',
      labelColor: '#333',
      inputTextColor: '#333'
    }
  },
  category: 'auth',
  icon: '🔑',
  name: '로그인',
  skinnable: LoginSkinnable
});

// 컴포넌트 및 타입 내보내기
export { LoginWrapper as LoginComponent };
export { default as LoginEditor } from './Login.editor';
export { default as LoginProperties } from './Login.properties';
export * from './Login.types';